<template>
  <article>
    <h2>About Us</h2>
    <p>
      Welcome to the internet home of Chapter Z.
      We would like to invite you and your family to join us for some
      fun and motorcycle riding. Our Chapter has a diverse schedule of
      activities that includes local and long trips to motorcycling activities,
      scenic trips, and “Bucket List” locations. We try to have at least one
      long trip lasting a week or more and several weekend trips every year.
      There are day trips to local festivals and other Chapters’ events, as well
      as weekly evening rides for dinner or ice-cream. We strive to keep our
      calendar full, allowing our members plenty of opportunity to pick and
      choose the events in which they would like to participate.
    </p>
  </article>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style scoped>
h4 {
  margin: 0;
}

ul li {
  margin-bottom: 12px;
}
</style>
